import React, { useEffect } from 'react'
import { useState, useRef } from 'react';

export default function MediaPlayer(props) {

    const source = props.source;
    const initialDelay = props.initialDelay || 0;
    const [isPaused, setPaused] = useState(true);
    const isPausedRef = useRef(isPaused);
    const setBack = props.setBack;
    const onEnd = props.onEnd || (() => { });
    const nbOfLoops = props.nbOfLoops || 1;
    const [loop, setLoop] = useState(1);
    const loopRef = useRef(loop);

        React.useEffect(() => {
        if (setBack) {
            const video = document.getElementById('video');
            video.currentTime = 0;
            pause();
        }
    }, [props.setBack]);

    React.useEffect(() => {
        console.log('launched');
        pause();
    }, []);

    React.useEffect(() => {
        isPausedRef.current = props.paused;
        if (isPausedRef.current) {
            pause();
        } else {
            play();
        }
    }, [props.paused]);

    //Called when the video ends
    React.useEffect(() => {
        const video = document.getElementById('video');
        video.addEventListener('ended', () => {
            if (loopRef.current < nbOfLoops) {
                console.log(loopRef.current);
                setLoop(loopRef.current + 1);
                video.currentTime = 0;
                play();
            }
            onEnd();
        });
    }, []);

    function play() {
        const video = document.getElementById('video');
        video.play();
        setPaused(false);
        console.log('play');
    }

    function pause() {
        const video = document.getElementById('video');
        video.pause();
        setPaused(true);
        console.log('pause');
    }

    React.useEffect(() => {
        loopRef.current = loop;
    }, [loop]);

    return (
        <div
            className="framePlayer"
            style={{ position: 'absolute', top: 0, left: 0, width: '660px', height: '500px' }}
            id={props.id}
        >
            <video id="video" width="100%" height="100%">
                <source src={process.env.PUBLIC_URL + `/assets/movies/${source}.mp4`} type="video/mp4" />
                Your browser does not support HTML video.
            </video>
        </div >
    )
}
